jQuery(".themes-content").on("click", ".themes-content__theme", function () {
  // console.log(".themes-content__theme clicked");
  $(this).toggleClass("active");
});

jQuery(".themes-content__items").on(
  "click",
  ".themes-content__item",
  function (e) {
    e.stopPropagation();
    $(this).toggleClass("active");
  }
);
